import { initialPostsState } from 'redux/initialState';
import { status } from 'constants/general';

import postsActionTypes from './action-types';

const postsReducer = (state = initialPostsState, { type, payload }) => {
  switch (type) {
    case postsActionTypes.FETCH_POSTS_LIST:
      return {
        ...state,
        postsList: {
          status: status.FETCHING,
          override: payload.override,
          details: payload.override ? {} : state.postsList.details,
        },
      };

    case postsActionTypes.FETCH_POSTS_LIST_SUCCESS:
      return {
        ...state,
        postsList: {
          status: status.SUCCESS,
          override: payload.override,
          details: {
            ...payload,
            results: payload.override
              ? payload.results
              : [...state.postsList.details.results, ...payload.results],
          },
        },
      };

    case postsActionTypes.FETCH_POSTS_LIST_FAIL:
      return {
        ...state,
        postsList: {
          status: status.FAIL,
          override: payload.override,
          details: payload.override ? {} : state.postsList.details,
        },
      };

    case postsActionTypes.FETCH_ADD_OR_EDIT_POST_SUBMISSION:
      return {
        ...state,
        addOrEditPost: {
          status: status.FETCHING,
        },
      };

    case postsActionTypes.FETCH_ADD_OR_EDIT_POST_SUBMISSION_SUCCESS:
      return {
        ...state,
        addOrEditPost: {
          status: status.SUCCESS,
        },
      };

    case postsActionTypes.FETCH_ADD_OR_EDIT_POST_SUBMISSION_FAIL:
      return {
        ...state,
        addOrEditPost: {
          status: status.FAIL,
        },
      };

    case postsActionTypes.FETCH_DELETE_POST_SUBMISSION:
      return {
        ...state,
        deletePost: {
          status: status.FETCHING,
        },
      };

    case postsActionTypes.FETCH_DELETE_POST_SUBMISSION_SUCCESS:
      return {
        ...state,
        deletePost: {
          status: status.SUCCESS,
        },
      };

    case postsActionTypes.FETCH_DELETE_POST_SUBMISSION_FAIL:
      return {
        ...state,
        deletePost: {
          status: status.FAIL,
        },
      };

    case postsActionTypes.FETCH_RSS_FEED_LIST:
      return {
        ...state,
        rssFeedList: {
          status: status.FETCHING,
        },
      };

    case postsActionTypes.FETCH_RSS_FEED_LIST_SUCCESS:
      return {
        ...state,
        rssFeedList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case postsActionTypes.FETCH_RSS_FEED_LIST_FAIL:
      return {
        ...state,
        rssFeedList: {
          status: status.FAIL,
        },
      };

    case postsActionTypes.FETCH_ADD_RSS_FEED_SUBMISSION:
      return {
        ...state,
        addRssFeed: {
          status: status.FETCHING,
        },
      };

    case postsActionTypes.FETCH_ADD_RSS_FEED_SUBMISSION_SUCCESS:
      return {
        ...state,
        addRssFeed: {
          status: status.SUCCESS,
        },
      };

    case postsActionTypes.FETCH_ADD_RSS_FEED_SUBMISSION_FAIL:
      return {
        ...state,
        addRssFeed: {
          status: status.FAIL,
        },
      };

    case postsActionTypes.FETCH_EDIT_RSS_FEED_SUBMISSION:
      return {
        ...state,
        editRssFeed: {
          status: status.FETCHING,
        },
      };

    case postsActionTypes.FETCH_EDIT_RSS_FEED_SUBMISSION_SUCCESS:
      return {
        ...state,
        editRssFeed: {
          status: status.SUCCESS,
        },
      };

    case postsActionTypes.FETCH_EDIT_RSS_FEED_SUBMISSION_FAIL:
      return {
        ...state,
        editRssFeed: {
          status: status.FAIL,
        },
      };

    default:
      return state;
  }
};

export default postsReducer;
